module.exports = __webpack_public_path__ + "img/218MGC_218MGD.d930f6f4.png";